import { Pipe, PipeTransform } from '@angular/core';
import {SafePipe} from "./safe.pipe";

@Pipe({
  name: 'assetImageUrl'
})
export class AssetImageUrlPipe implements PipeTransform {

  constructor(private safe: SafePipe) {
  }

  transform(value: string): unknown {
    return this.safe.transform('assets/img/' + value, 'url');
  }

}
